import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bibShape, bibFieldShape } from '@bibliocommons/bc-prop-types';

import { selectMediaSummaryForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { selectCatalogBib, createBibFieldSelector } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import MediaSummary from './MediaSummary';

const selectAudienceInfo = createBibFieldSelector('AUDIENCE', 'AUDIENCEGENERAL');
const selectLanguageInfo = createBibFieldSelector('NOTES', 'LANGUAGE');

export class MediaSummaryContainer extends React.PureComponent {
  render() {
    return <MediaSummary {...this.props} />;
  }
}

MediaSummaryContainer.propTypes = {
  bib: bibShape.isRequired,
  mediaSummary: PropTypes.string,
  audienceInfo: bibFieldShape,
  languageInfo: bibFieldShape
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);
  return {
    bib,
    mediaSummary: selectMediaSummaryForCurrentBib(state),
    audienceInfo: selectAudienceInfo(state),
    languageInfo: selectLanguageInfo(state)
  };
};

export default connect(mapStateToProps)(MediaSummaryContainer);
